module.exports = __webpack_public_path__ + "img/exam_title.60da16e1.png";